<template lang="html">
  <div>
    <div class="vx-row">
      <div class="vx-col md:w-1/3 w-full mt-5">
        <vs-input :label="$t('name') | capitalize" v-model="data.name" class="w-full" name="Name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
      </div>
      <div class="vx-col md:w-1/3 w-full mt-5">
        <vs-input :label="$t('city') | capitalize" v-model="data.addressCity" class="w-full" name="City" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('City')">{{ errors.first('City') }}</span>
      </div>
      <div class="vx-col md:w-1/3 w-full mt-5">
        <vs-input :label="$t('zip') | capitalize" v-model="data.addressZip" class="w-full" name="Zip" v-validate="'required|min:5'"/>
        <span class="text-danger text-sm" v-show="errors.has('Zip')">{{ errors.first('Zip') }}</span>
      </div>
      <div class="vx-col md:w-1/3 w-full mt-5">
        <vs-input :label="$t('address') + ' 1' | capitalize" v-model="data.address1" class="w-full" name="Address 1" v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('Address 1')">{{ errors.first('Address 1') }}</span>
      </div>
      <div class="vx-col md:w-1/3 w-full mt-5">
        <vs-input :label="$t('address') + ' 2' | capitalize" v-model="data.address2" class="w-full" name="Address 2"/>
      </div>
    </div>
    <div class="vx-row mt-5">
      <div class="vx-col md:w-1/3 w-full mt-5">
        <vs-input :label="$t('manager_name') | capitalize" v-model="data.managerName" class="w-full" name="Manager Name" v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('Manager Name')">{{ errors.first('Manager Name') }}</span>
      </div>
      <div class="vx-col md:w-1/3 w-full mt-5">
        <vs-input :label="$t('manager_email') | capitalize" v-model="data.managerEmail" class="w-full" name="Manager Email" v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('Manager Email')">{{ errors.first('Manager Email') }}</span>
      </div>
      <div class="vx-col md:w-1/3 w-full mt-5">
        <vs-input :label="$t('manager_phone') | capitalize" v-model="data.managerPhone" class="w-full" name="Manager Phone" v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('Manager Phone')">{{ errors.first('Manager Phone') }}</span>
      </div>
    </div>
    <div class="vx-row mt-5">
      <div class="vx-col md:w-1/6 w-full mt-5 ml-auto">
        <vs-button color="primary" type="filled" @click="submit" class="w-full" :disabled="disabledSubmit">
          {{ $t('save') | capitalize }}
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    submit() {
      this.$validator.reset()
      this.$emit('submit', this.data)
    }
  },

  computed: {
    disabledSubmit() {
      return this.errors.any() ||
        this.data.name === '' ||
        this.data.address1 === '' ||
        this.data.address2 === '' ||
        this.data.addressCity === '' ||
        this.data.addressZip === '' ||
        this.data.managerEmail === '' ||
        this.data.managerName === '' ||
        this.data.managerPhone === ''
    }
  },

  props: {
    data: {
      default: () => ({
        name: '',
        address1: '',
        address2: '',
        addressCity: '',
        addressZip: '',
        managerEmail: '',
        managerName: '',
        managerPhone: ''
      })
    },
  }
}
</script>

<style lang="css" scoped>
</style>
